import { Component } from "@angular/core";

@Component({
  selector: "app-profile-version-action",
  template: ` <a mat-stroked-button routerLink="/dev">Development tools</a> `,
  styles: [
    `
      :host {
        display: block;
        margin-top: 8px;
      }
    `,
  ],
  standalone: false,
})
export class DevelopmentToolsLinkComponent {}
